import React, { useState, useContext, useRef } from "react";
import { ReactTyped } from "react-typed";
import "./Hero.css";
import ProductsHero from "./pages/ProductsHero";
import About from "./pages/About";
import { TranslationContext } from "../components/TranslationContext";
import Features from "./pages/Features";
import ScrollDown from "./images/scrollDown-gorra.png";

function Hero() {
  const { translation } = useContext(TranslationContext);


  const featuresRef = useRef(null);

  const handleScroll = () => {
    featuresRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <div className="hero-container">
        <div className="hero-small-container">
          <h1>
          {translation.welcome} <br /> Detallitos las Nieves
          </h1>

            <h2 className="second-typed">
              <ReactTyped
                strings={[translation.heroH2]}
                typeSpeed={70}
                backSpeed={30}
                showCursor={false} 
              />
            </h2>
          
          <img
            src={ScrollDown}
            alt="scrolldown-button"
            className="scroll-button"
            onClick={handleScroll}
          />
        </div>
      </div>

      
      <div ref={featuresRef}>
        <Features />
      </div>

      <ProductsHero />
      <About />
    </div>
  );
}

export default Hero;
